import type { ColumnDef } from '@tanstack/react-table';

import { type GetSitesQuery, SiteState, SiteType } from 'data/__generated__';
import { textColumn, multiSelectColumn } from 'components/DataTable';

import { StatusTag } from 'pages/Sites/components/StatusTag';
import { TypeTag } from 'pages/Sites/components/TypeTag';
import { SITE_STATES_LABELS } from 'pages/Sites/constants/states';
import { SITE_TYPES_LABELS } from 'pages/Sites/constants/types';

export type StockSiteRow = GetSitesQuery['sites'][number];

type StockSiteFilterInput = {
    searchValue: string;
    state: SiteState[];
    type: SiteType[];
};

export const stocksColumns: ColumnDef<StockSiteRow, unknown>[] = [
    textColumn<StockSiteRow, StockSiteFilterInput>({
        accessorKey: 'name',
        header: 'Site',
        defaultVisible: true,
    }),
    multiSelectColumn<StockSiteRow, StockSiteFilterInput>({
        accessorKey: 'type',
        header: 'Type',
        filterKey: 'type',
        defaultVisible: true,
        options: Object.values(SiteType).map((type) => ({ value: type, label: SITE_TYPES_LABELS[type] })),
        renderOption: (option) => <TypeTag type={option.value as SiteType} />,
        cell: ({ row }) => <TypeTag type={row.original.type} />,
    }),
    multiSelectColumn<StockSiteRow, StockSiteFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        options: Object.values(SiteState).map((state) => ({ value: state, label: SITE_STATES_LABELS[state] })),
        renderOption: (option) => <StatusTag state={option.value as SiteState} />,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
    }),
];
